/* @flow */
import {
  STORE_SCROLL_POSITION,
  SET_DETAIL_PANEL_OPTIONS,
} from './action-types';
import type { DetailPanelRecordType } from './types';

export const storeScrollPosition = (key: string, value: number): Object => ({
  type: STORE_SCROLL_POSITION,
  payload: { key, value },
});

export const setDetailPanelOptions = (options: DetailPanelRecordType): Object => ({
  type: SET_DETAIL_PANEL_OPTIONS,
  payload: options,
});



// WEBPACK FOOTER //
// ./src/app/modules/display/actions.js